(function () {
  class GambleIntro extends PIXI.Container {
    constructor() {
      super();

      this._numFS = undefined;
      this._callbackOnBaseHidden = undefined;
      this._callback = undefined;
      this._screenDim = undefined;
      this._splashContinue = undefined;

      this._totemParent = undefined;
      this._popup = undefined;
      this._introText1 = undefined;
      this._freespinIntroElements = [];
      this.visible = false;
      this._screenDimTargetAlpha = 0.6;

      this._startFreeSpinsButton = undefined;
      this._gambleButton = undefined;

      this.youHaveFreeSpinsText = undefined;
      this._winChance = undefined;

      this._freeSpinsIntroOutro = undefined;

      this._fsText1 = undefined;
      this._fsText2 = undefined;
      this._fsText3 = undefined;

      this._possibleValues = undefined;

      this._winIntroAnim = undefined;
      this._winAnimIntroPositions = [];

      this._currentFSIndex = 0;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.gambleBorder = resourceManager.get(
        "gambleIntroContainer:GambleIntro:gambleBorder"
      );

      this._welcomeToText = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsWelcomeText"
      );
      this.youHaveFreeSpinsText = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsYouHaveText"
      );

      this._startFreeSpinsButton = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsButton"
      );
      this._gambleButton = resourceManager.get(
        "gambleIntroContainer:GambleIntro:gambleButton"
      );

      this._gambleDisclaimer = resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer"
      );
      this._gambleSpin = resourceManager.get("gambleSpinContainer:GambleSpin");

      this._startFreeSpinsButton.mousedown =
        this._startFreeSpinsButton.touchstart = this.onClickedStart.bind(this);
      this._gambleButton.mousedown = this._gambleButton.touchstart =
        this.onClickedGamble.bind(this);

      this._freeSpinsIntroOutro = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
      );

      this._fsText1 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsNumber1"
      );
      this._fsText2 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsNumber2"
      );
      this._fsText3 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsNumber3"
      );
      this._freeSpinsSplit1 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsSplit1"
      );
      this._freeSpinsSplit2 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsSplit2"
      );
      this._freeSpinsSplit3 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsSplit3"
      );
      this._burstAnim = resourceManager.get(
        "gambleIntroContainer:GambleIntro:burstAnim"
      );

      this._introBurst = resourceManager.get(
        "gambleIntroContainer:GambleIntro:introBurst"
      );
      this._introBurst.visible = false;

      this._introBlast = resourceManager.get(
        "gambleIntroContainer:GambleIntro:introBlast"
      );
      this._introBlast.gotoAndStop(0);

      this._winIntroAnim = resourceManager.get(
        "gambleIntroContainer:GambleIntro:burstAnim"
      );

      this._emitterDiamondSmall = particleManager.createEmitter(
        "bigwin_emitter_2",
        "gambleIntroContainer:GambleIntro:particlesContainer",
        0,
        0,
        false
      );
      this._emitterDiamondSmall.particleEmitter.emit = false;

      this._emitterDiamondBig = particleManager.createEmitter(
        "bigwin_emitter_4",
        "gambleIntroContainer:GambleIntro:particlesContainer",
        0,
        0,
        false
      );
      this._emitterDiamondBig.particleEmitter.emit = false;

      this.orientationChange();

      this.createIntroTimeline();

      messageBus.subscribe("Gamble:Risk", this.onCommittedToGamble.bind(this));
      messageBus.subscribe("Gamble:Collect", this.onClickedStart.bind(this));
      messageBus.subscribe(
        "Gamble:OfferGamble",
        this.onGambleOffered.bind(this)
      );

      Reflex.registerEventHandler(
        "orientationChange",
        this.orientationChange.bind(this)
      );
    }

    orientationChange() {
      this._winAnimIntroPositions = [];
      this._winAnimIntroPositions.push(this._fsText1.position.get());
      this._winAnimIntroPositions.push(this._fsText2.position.get());
      this._winAnimIntroPositions.push(this._fsText3.position.get());

      this._winIntroAnim.position.set(
        this._winAnimIntroPositions[this._currentFSIndex].x,
        this._winAnimIntroPositions[this._currentFSIndex].y
      );

      var pos = this.youHaveFreeSpinsText.position;
      this._introBlast.position = pos;
      this._introBurst.position = pos;
      this._emitterDiamondSmall.position = pos;
      this._emitterDiamondBig.position = pos;
    }

    onClickedStart() {
      this._startFreeSpinsButton.interactive = false;
      this._gambleButton.interactive = false;
      this._callback("collect");
      this.visible = false;
    }

    doFS() {
      const self = this;
      timerManager.addTimer(
        10,
        function (progress) {
          self.alpha = 1 - progress;
        },
        function () {
          resourceManager.getContainer("fsBackgroundContainer").visible = true;
          resourceManager.getContainer("backgroundContainer").visible = false;
          resourceManager.getContainer("freeSpinsContainer").visible = true;

          self.alpha = 1;
          self.visible = false;

          self._callback();
        }
      );
    }

    onCommittedToGamble() {
      this._callback("gambled");
    }

    reactivate(numFS, winChance, loseChance, callback) {
      this._winChance = winChance;
      this._loseChance = loseChance;
      this._callback = callback;

      this._gambleSpin.start(
        this._winChance,
        this._loseChance,
        this._possibleValues,
        false
      );
    }

    onGambleOffered() {
      let showDisclaimerButton = resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer:showAgainToggle"
      );
      let inRecovery = gameController.getIsRecovery();
      let show = showDisclaimerButton.getShowDisclaimer();

      const self = this;
      if (show && !inRecovery) {
        this._gambleDisclaimer.start(
          this._winChance,
          this._loseChance,
          this._possibleValues
        );
      } else {
        this._gambleSpin.start(
          this._winChance,
          this._loseChance,
          this._possibleValues,
          true
        );
      }
    }

    onClickedGamble() {
      messageBus.postImmediate("Gamble:OfferGamble");
      soundManager.play("buttonPressV1");
    }

    doShowIntro(numFS, callback) {
      this._numFS = numFS;
      this._callback = callback;
      this._freeSpinsIntroOutro.showIntro(this._numFS, this.doFS.bind(this));
    }

    createIntroTimeline() {
      this._introTimeline = gsap
        .timeline({ paused: true })
        .call(() => {
          soundManager.play("freeSpinsPopup");

          this._introBlast.gotoAndPlay(0);

          this._emitterDiamondSmall.particleEmitter.emit = true;
          this._emitterDiamondBig.particleEmitter.emit = true;

          this._introBurst.scale.x = 0;
          this._introBurst.scale.y = 0;
          this._introBurst.visible = true;
          this.rotateBurst();
        })
        .to(
          this._introBurst.scale,
          {
            duration: 0.4,
            x: 1,
            y: 1,
          },
          "<+0.2"
        )
        .add(
          gsap.delayedCall(0.5, () => {
            this.showIntro();

            this._emitterDiamondSmall.particleEmitter.emit = false;
            this._emitterDiamondBig.particleEmitter.emit = false;
          })
        )
        .to(
          this._introBurst.scale,
          {
            duration: 0.3,
            x: 0,
            y: 0,
            onComplete: () => {
              this._introBurst.visible = false;
            },
          },
          "<"
        );
    }

    rotateBurst() {
      this._introBurst.rotation = 0;

      gsap.to(this._introBurst, {
        duration: 2,
        rotation: Math.PI * 2,
        repeat: 1,
      });
    }

    start(
      numFS,
      winChance,
      loseChance,
      possibleValues,
      fsIndex,
      hiddenCallback,
      callback
    ) {
      this._numFS = numFS;
      this._winChance = winChance;
      this._loseChance = loseChance;

      this._callbackOnBaseHidden = hiddenCallback;
      this._callback = callback;

      this.visible = true;
      this._possibleValues = possibleValues;

      this._fsText1.text = this._possibleValues[0];
      this._fsText2.text = this._possibleValues[1];
      this._fsText3.text = this._possibleValues[2];

      resourceManager.getContainer("gambleIntroContainer").visible = true;

      this.gambleBorder.visible = false;
      this._welcomeToText.visible = false;
      this.youHaveFreeSpinsText.visible = false;
      this._fsText1.visible = false;
      this._fsText2.visible = false;
      this._fsText3.visible = false;
      this._freeSpinsSplit1.visible = false;
      this._freeSpinsSplit2.visible = false;
      this._freeSpinsSplit3.visible = false;
      this._burstAnim.visible = false;
      this._startFreeSpinsButton.visible = false;
      this._gambleButton.visible = false;

      if (numFS === 7) {
        fsIndex = 0;
      } else if (numFS === 9) {
        fsIndex = 1;
      } else if (numFS === 11) {
        fsIndex = 2;
      }

      this._winIntroAnim.position.set(
        this._winAnimIntroPositions[fsIndex].x,
        this._winAnimIntroPositions[fsIndex].y
      );
      this._currentFSIndex = fsIndex;

      messageBus.post("Gamble:IntroVisible");
      var recoveryController = resourceManager.getController(
        "GameRecoveryController"
      );

      let inRecovery = gameController.getIsRecovery();
      if (inRecovery) {
        recoveryController.onIntroVisible();
        this.onGambleOffered();
      }

      this._callbackOnBaseHidden();

      this._introTimeline.play(0);
    }

    showIntro() {
      this.bounceIn(this.gambleBorder, 0.5);
      this.bounceIn(this._welcomeToText, 1);
      this.bounceInFreeSpinsText(this.youHaveFreeSpinsText, 1, this._numFS);
      this.bounceIn(this._fsText1, 1);
      this.bounceIn(this._fsText2, 1);
      this.bounceIn(this._fsText3, 1);
      this.bounceIn(this._freeSpinsSplit1, 1);
      this.bounceIn(this._freeSpinsSplit2, 1);
      this.bounceIn(this._freeSpinsSplit3, 1);
      this.bounceIn(this._burstAnim, 1);
      this.bounceIn(this._startFreeSpinsButton, 1.2);
      this.bounceIn(this._gambleButton, 1.2);
    }

    setActive() {
      this._startFreeSpinsButton.interactive = true;
      this._gambleButton.interactive = true;
    }

    bounceIn(object, delay) {
      const scaleTo = object.scale.x;

      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: 1,
          ease: "Bounce.easeOut",
          x: scaleTo,
          y: scaleTo,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
        }
      );
    }

    bounceInFreeSpinsText(object, delay, numFS) {
      const scaleTo = object.scale.x;

      let self = this;
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: 1,
          ease: "Bounce.easeOut",
          x: scaleTo,
          y: scaleTo,
          onStart: () => {
            self.youHaveFreeSpinsText.setTranslationParameters(numFS);
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }
  }

  let gambleIntroCreator = function (json) {
    return new GambleIntro();
  };

  let gambleIntroInitialiser = function (json, fsIntro) {
    fsIntro.initialise();
  };

  let gambleIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "GambleIntro",
    gambleIntroCreator,
    gambleIntroInitialiser,
    gambleIntroFilesRequired
  );
})();
